import { useState } from "react";
import { FaRegCheckCircle } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

const steps = [
  {
    id: 0,
    title: "Login or Register",
    desc: "Login with email and or phone number, or register a new account, it's that easy!",
    detail: "Create an account quickly with multiple sign-in options and manage your tasks search from one platform.",

    // input: video showing how to login or register
  },
  {
    id: 1,
    title: "Personal Task Recommendation",
    desc: "Using our Task matching system, we will not only recommend you jobs based on your previous searches, likes and applications, we will recommend you to clients in need of your skils.",
    detail: "Our algorithm matches your past searches and application history to recommend jobs you're most likely to get and vice versa.",
  },
  {
    id: 2,
    title: "Quick Apply and Bids",
    desc: "Easily apply to multiple jobs with one click! Don't like an offer? no wahala, submit a bid with one click and the client will consider your rates.",
    detail: "Submit multiple job applications instantly with a single click. If you find a job that doesn't meet your expectations, you can quickly submit a bid with your preferred rate for consideration.",
    // input: video showing how to apply and bid
  },
  {
    id: 3,
    title: "Community",
    desc: "Be part of a growing community of taskers and clients. Share experiences, tips, and get support from fellow users. learn from others, and grow together.",
    detail: " Join our vibrant community of taskers and clients. Share your experiences, learn from others, and grow together. Engage in discussions, ask questions, and get support from fellow users.",
    // input: video showing how to join the community
  },
];

export default function JobSteps() {
  const [activeStep, setActiveStep] = useState<number | null>(1); // default to step 2

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      {/* Header */}
      <div className="text-center mb-12">
        <span className="text-sm uppercase text-purple-800 font-semibold">How it works</span>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2">Make Your Urgent 2k</h2>
        <p className="mt-3 text-gray-500 max-w-2xl mx-auto">
          Hitmeup is Nigeria's new favorite gig-to-gig platform. We connect people who need low to medium skilled errands done with taskers ready to earn. From deliveries and price checks to queuing and home assistance, finding help is fast and easy.
          Hitmeup dey for you!

        </p>
      </div>

      {/* Step Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
        {steps.map((step) => (
          <button
            key={step.id}
            onClick={() => setActiveStep(step.id)}
            className={`border rounded-lg p-6 text-left transition-all duration-300 focus:outline-none
              ${activeStep === step.id ? "border-purple-600 shadow-md bg-white-50" : "border-gray-200 bg-white hover:shadow-sm"}
            `}
          >
            <div className="text-sm font-bold text-gray-400 mb-1">
              {String(step.id + 1).padStart(2, "0")}
            </div>
            <h3 className={`text-lg font-semibold mb-2 ${activeStep === step.id ? "text-purple-600" : "text-gray-800"}`}>
              {step.title}
            </h3>
            <p className="text-sm text-gray-600">{step.desc}</p>
          </button>
        ))}
      </div>

      {/* Detail Block */}
      {activeStep !== null && (
        <div className="relative mt-12 bg-white border rounded-lg p-8 shadow-sm transition-all duration-300">
          {/* Close Button */}
          <button
            onClick={() => setActiveStep(null)}
            className="absolute top-4 right-4 text-gray-400 hover:text-red-500 text-xl"
            aria-label="Close detail view"
          >
            <IoClose />
          </button>

          <h4 className="text-blue-600 font-bold text-sm mb-2">{String(activeStep + 1).padStart(2, "0")}</h4>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">{steps[activeStep].title}</h3>
          <p className="text-gray-600 mb-4">{steps[activeStep].detail}</p>

          {activeStep === 1 && (
            <ul className="text-sm text-gray-700 space-y-2">
              <li className="flex items-start gap-2">
                <FaRegCheckCircle className="text-green-500 mt-1" />
                <span>
                  <strong>Easy Apply</strong>: Instantly apply to recommended jobs based on your profile.
                </span>
              </li>
              <li className="flex items-start gap-2">
                <FaRegCheckCircle className="text-green-500 mt-1" />
                <span>Tailored job matches improve your chances of being hired.</span>
              </li>
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
